module.exports = __webpack_public_path__ + "img/2.71f415e0.webp";